<button *ngIf="data?.addToWallet" mat-icon-button class="close-banner" (click)="close()">
    <mat-icon>close</mat-icon>
</button>

<div class="cc-validation-disclaimer" *ngIf="data.provider == 'CreditGuard'">
	<div>{{ 'MESSAGES.CREDIT_CARD_3DS_DISCLAIMER' | translate }}</div>
    <small>{{'MESSAGES.CREDIT_CARD_3DS_DISCLAIMER_more' | translate}}</small>
</div>

<mat-checkbox
    *ngIf="showAddToWallet"
    class="save-to-wallet"
    name="updateWallet"
    (change)="markSaveToWalletPayment($event)"
>
    {{'SAVE_ACCOUNT_PAYMENT_INFO' | translate}}
</mat-checkbox>

<iframe id="ex_iframe" [src]="trustedIframeUrl" (load)="onFrameLoaded($event)"></iframe>
